import { connect } from 'react-redux'

import {
  setSignupData,
  signup,
  setPasswordMatch,
  setError,
  setErrorClean,
  getValidateEmail,
} from 'reduxpath/ducks/Auth'

import Form from './units'

const mapStateToProps = state => ({
  signupData: state.Auth.signupData,
  auth: state.Auth,
})

const mapDispatchToProps = dispatch => ({
  handleInputChange(signupData) {
    return (e) => {
      const data = {
        [e.target.name]: e.target.value,
      }
      const comparePassword = e.target.name === 'password'
        ? 'retypePassword'
        : 'password'
      if (e.target.name === 'password' || e.target.name === 'retypePassword') {
        dispatch(setPasswordMatch(e.target.value === signupData[comparePassword]))
      }
      dispatch(setSignupData(data))
    }
  },

  handleSignup(signupData, isPasswordMatch) {
    return (e) => {
      e.preventDefault()
      if (isPasswordMatch) {
        dispatch(
          getValidateEmail(signupData.email, (user) => {
            if (user.count > 0) {
              return dispatch(setError({ message: 'Email has been taken' }))
            }
            const data = {
              email: signupData.email,
              firstName: signupData.firstName,
              lastName: signupData.lastName,
              password: signupData.password,
              verified: signupData.verified,
              hasAgreedTnc: signupData.hasAgreedTnc,
            }
            return dispatch(signup(data, () => {
              dispatch(setErrorClean())
            }))
          }),
        )
      }
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Form)
